/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewlawyeranchor3Inputs */

const en_letterpreviewlawyeranchor3 = /** @type {(inputs: Letterpreviewlawyeranchor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Portuguese lawyer would charge €200–500 to draft a comparable letter. Yours pulls from your own case file — included in the free tier.`)
};

const pt_letterpreviewlawyeranchor3 = /** @type {(inputs: Letterpreviewlawyeranchor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um advogado português cobraria entre 200 € e 500 € para redigir uma carta comparável. A sua é redigida a partir do seu próprio dossier — incluída no nível gratuito.`)
};

/**
* | output |
* | --- |
* | "A Portuguese lawyer would charge €200–500 to draft a comparable letter. Yours pulls from your own case file — included in the free tier." |
*
* @param {Letterpreviewlawyeranchor3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewlawyeranchor3 = /** @type {((inputs?: Letterpreviewlawyeranchor3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewlawyeranchor3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewlawyeranchor3(inputs)
	return pt_letterpreviewlawyeranchor3(inputs)
});
export { letterpreviewlawyeranchor3 as "letterPreviewLawyerAnchor" }